import React from "react"
import PropTypes from "prop-types"
import SentConnectItem from './SentConnectItem'
import ConnectSectionHeader from './ConnectSectionHeader'

class SentConnectRequests extends React.Component {
  renderRequests() {
    return(this.props.requestedConnects.map((req, i) => {
      return (
        <SentConnectItem
          req={req}
          key={i}
          missingImg={this.props.missingImg}
        />
      )
    }))
  }

  render() {
    return(
      <section className="connectsSection">
        <ConnectSectionHeader
          icon="clock"
          title="Sent Connect Requests"
          subtitle="Waiting for their response — hang tight!"
        />
        {this.renderRequests()}
      </section>
    )
  }
}

SentConnectRequests.propTypes = {
  missingImg: PropTypes.string.isRequired,
  requestedConnects: PropTypes.array.isRequired,
}

export default SentConnectRequests
